<app-moderation-inbox #moderationInbox [showLoading]="false" />
<div class="mt-4">
  <h2 class="mb-3">{{ 'REPORT_SEARCH_TITLE' | translate }}</h2>

  @if (
    moderationInbox.loading ||
    (loadingCategories$ | async) ||
    (loadingCarReports$ | async) ||
    (loadingRealEstateReports$ | async)
  ) {
    <div class="text-center my-3">
      <app-loading></app-loading>
    </div>
  }

  @if (categories$ | async; as categories) {
    <!-- Search Form -->
    <form [formGroup]="searchForm" (ngSubmit)="search()" class="p-4 bg-dark rounded">
      <div class="row">
        <div class="col-lg-6 col-md-12 pb-3">
          <app-dropdown-checkbox-select
            id="reasonsSelect"
            class="required multi-line-select"
            [items]="categories.adReportReasons"
            formControlName="reasons"
            placeholder="{{ 'CAR_REPORT_SEARCH_REASON' | translate }}"
            [selectableGroup]="false"
            bindLabel="description"
          >
          </app-dropdown-checkbox-select>
        </div>
        <div class="col-lg-6 col-md-12 pb-3">
          <app-dropdown-checkbox-select
            id="statusesSelect"
            class="required multi-line-select"
            [items]="categories.adReportStatuses"
            formControlName="statuses"
            placeholder="{{ 'CAR_REPORT_SEARCH_STATUS' | translate }}"
            [selectableGroup]="false"
            bindLabel="description"
          >
          </app-dropdown-checkbox-select>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <div class="row">
            <div class="col-12">
              <button type="submit" class="btn btn-primary">
                {{ 'SEARCH_BUTTON' | translate }}
              </button>
              <button
                type="button"
                class="btn btn-secondary bg-black text-primary mx-3"
                (click)="reset()"
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    @let carReports = carReports$ | async;
    @let realEstateReports = realEstateReports$ | async;
    @let loadingCarReports = loadingCarReports$ | async;
    @let loadingRealEstateReports = loadingRealEstateReports$ | async;

    @if (carReports && carReports.length > 0) {
      <table class="table mt-4">
        <thead>
          <tr>
            <th scope="col">{{ 'REPORT_TABLE_REPORTED_AD' | translate }}</th>
            <th scope="col">{{ 'REPORT_TABLE_REPORTED_BY' | translate }}</th>
            <th scope="col">{{ 'REPORT_TABLE_REASON' | translate }}</th>
            <th scope="col">{{ 'REPORT_TABLE_COMMENT' | translate }}</th>
            <th scope="col">{{ 'REPORT_TABLE_STATUS' | translate }}</th>
            <th scope="col">{{ 'REPORT_TABLE_C_DATE' | translate }}</th>
            <th scope="col">{{ 'REPORT_TABLE_U_DATE' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (report of carReports; track $index) {
            <tr
              [ngClass]="{
                'table-danger': report.status === statuses.Pending,
                'table-success': report.status === statuses.ActionTaken,
                'table-secondary': report.status === statuses.Dismissed,
              }"
            >
              <td>
                <span
                  routerLink="/cars/{{ report.car.id }}"
                  class="cursor-poiner text-decoration-underline"
                  >{{ report.car.model }} {{ report.car.name }}</span
                >
              </td>
              <td>
                <span
                  routerLink="/users/{{ report.user.id }}"
                  class="cursor-poiner text-decoration-underline"
                  >{{ report.user.name }}</span
                >
              </td>
              <td>{{ report.reason | translate }}</td>
              <td>{{ report.comment }}</td>
              <td>{{ report.status | translate }}</td>
              <td>{{ report.createdAt | date: 'dd.MM.yyyy hh:mm' }}</td>
              <td>{{ report.updatedAt | date: 'dd.MM.yyyy hh:mm' }}</td>
              <td>
                <div class="dropdown d-inline-block">
                  <button
                    class="btn d-flex max-content"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>

                  <ul class="dropdown-menu dropdown-menu-end py-0 icon-only transparent">
                    @if (
                      report.status === statuses.ActionTaken || report.status === statuses.Dismissed
                    ) {
                      <li>
                        <button
                          class="btn btn-danger w-100"
                          (click)="updateCarReport(report, statuses.Pending)"
                          [disabled]="moderationInbox.busy"
                        >
                          {{ 'MODERATION_pending' | translate }}
                        </button>
                      </li>
                    }

                    @if (report.status !== statuses.ActionTaken) {
                      <li>
                        <button
                          class="btn btn-success w-100"
                          (click)="updateCarReport(report, statuses.ActionTaken)"
                        >
                          {{ statuses.ActionTaken | translate }}
                        </button>
                      </li>
                    }

                    @if (report.status !== statuses.Dismissed) {
                      <li>
                        <button
                          class="btn btn-secondary w-100"
                          (click)="updateCarReport(report, statuses.Dismissed)"
                        >
                          {{ statuses.Dismissed | translate }}
                        </button>
                      </li>
                    }
                  </ul>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }

    @if (realEstateReports && realEstateReports.length > 0) {
      <table class="table mt-4">
        <thead>
          <tr>
            <th scope="col">{{ 'REPORT_TABLE_REPORTED_AD' | translate }}</th>
            <th scope="col">{{ 'REPORT_TABLE_REPORTED_BY' | translate }}</th>
            <th scope="col">{{ 'REPORT_TABLE_REASON' | translate }}</th>
            <th scope="col">{{ 'REPORT_TABLE_COMMENT' | translate }}</th>
            <th scope="col">{{ 'REPORT_TABLE_STATUS' | translate }}</th>
            <th scope="col">{{ 'REPORT_TABLE_C_DATE' | translate }}</th>
            <th scope="col">{{ 'REPORT_TABLE_U_DATE' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (report of realEstateReports; track $index) {
            <tr
              [ngClass]="{
                'table-danger': report.status === statuses.Pending,
                'table-success': report.status === statuses.ActionTaken,
                'table-secondary': report.status === statuses.Dismissed,
              }"
            >
              <td>
                <span
                  routerLink="/properties/{{ report.realEstate.id }}"
                  class="cursor-poiner text-decoration-underline"
                  >{{ report.realEstate.title }}</span
                >
              </td>
              <td>
                <span
                  routerLink="/users/{{ report.user.id }}"
                  class="cursor-poiner text-decoration-underline"
                  >{{ report.user.name }}</span
                >
              </td>
              <td>{{ report.reason | translate }}</td>
              <td>{{ report.comment }}</td>
              <td>{{ report.status | translate }}</td>
              <td>{{ report.createdAt | date: 'dd.MM.yyyy hh:mm' }}</td>
              <td>{{ report.updatedAt | date: 'dd.MM.yyyy hh:mm' }}</td>
              <td>
                <div class="dropdown d-inline-block">
                  <button
                    class="btn d-flex"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>

                  <ul class="dropdown-menu dropdown-menu-end py-0 icon-only transparent">
                    @if (
                      report.status === statuses.ActionTaken || report.status === statuses.Dismissed
                    ) {
                      <li>
                        <button
                          class="btn btn-danger"
                          (click)="updateRealEstateReport(report, statuses.Pending)"
                          [disabled]="moderationInbox.busy"
                        >
                          {{ 'MODERATION_pending' | translate }}
                        </button>
                      </li>
                    }

                    @if (report.status !== statuses.ActionTaken) {
                      <li>
                        <button
                          class="btn btn-success"
                          (click)="updateRealEstateReport(report, statuses.ActionTaken)"
                        >
                          <i class="bi bi-check-square-fill"></i>
                        </button>
                      </li>
                    }

                    @if (report.status !== statuses.Dismissed) {
                      <li>
                        <button
                          class="btn btn-secondary"
                          (click)="updateRealEstateReport(report, statuses.Dismissed)"
                        >
                          <i class="bi bi-x-square-fill"></i>
                        </button>
                      </li>
                    }
                  </ul>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }

    @if (
      isSearched &&
      !carReports?.length &&
      !realEstateReports?.length &&
      !loadingCarReports &&
      !loadingRealEstateReports
    ) {
      <div class="alert text-center mt-3 bg-primary text-dark">
        {{ 'NO_REPORTS_FOUND' | translate }}
      </div>
    }
  }
</div>
